/** The unit a document line takes from its article; pieces when the article does not say. */
export function productUnit(p: { unit?: string | null }, fallback = "pcs"): string {
  const u = p.unit?.trim();
  return u ? u : fallback;
}

/** True for the stored code of "pieces", which every screen shows in the reader's language. */
export function isPieces(unit: string | null | undefined): boolean {
  return (unit ?? "").trim().toUpperCase() === "PCS";
}
